'use strict';


// Parse URL into usefull metadata
function parseHref(documentLocation, href) {
  if (href.substr(0, 6) === 'mailto') return false;

  let splitHrefReg = /(((?:http|https):|)\/{2}(([a-zA-z0-9-.]*|)(?::|)(\d{4}|)|)|)((?:\/|)[a-zA-Z0-9.\/_\-%@\[\]&]*|)(\?.*|)(#.*|)/;
  let splitHref = splitHrefReg.exec(href);

  let hrefObj = {
    href: href,
    origin: splitHref[1],
    protocol: splitHref[2],
    hostname: splitHref[3],
    host: splitHref[4],
    port: splitHref[5],
    pathname: splitHref[6],
    search: splitHref[7],
    hash: splitHref[8],
    queries: []
  }

  // If href origin/hostname is null, the href supplied was a path ("/work/artwork-1")
  // So we return the site's current origin/hostname
  if (hrefObj.origin == null || hrefObj.origin === '') hrefObj.origin = documentLocation.origin;

  if (hrefObj.hostname == null || hrefObj.hostname === '') hrefObj.hostname = documentLocation.hostname;

  // An emtpy path value is no use, make it a base path value to indicate the root page
  if (hrefObj.pathname == null) hrefObj.pathname = '/';

  // If a empty string path was passed, return current path
  if (hrefObj.pathname === '') hrefObj.pathname = documentLocation.pathname;

  // Is a path only was passed without a leading /, append it to current path
  if (hrefObj.pathname[0] !== '/') hrefObj.pathname = documentLocation.pathname + '/' + hrefObj.pathname;

  // If protocol is null, a "//hostname.com/pathname" href was passed, so provide the doc protocol
  if (hrefObj.origin.substr(0, 2) === '//') hrefObj.origin = documentLocation.protocol + hrefObj.origin;

  // If protocol is null, set it to the document protocl
  if (hrefObj.protocol == null || hrefObj.protocol === '') hrefObj.protocol = documentLocation.protocol;

  // If host is null, a path argument was passed and it should be set to the hostname
  if (hrefObj.host == null) hrefObj.host = hrefObj.hostname;

  // Remove trailing / from path
  hrefObj.pathname = cleanPath(hrefObj.pathname);

  // Create href from url parts
  hrefObj.href = hrefObj.origin + hrefObj.pathname + hrefObj.search + hrefObj.hash;

  // Get searcg queries
  let searchReg = /(?:\?|(?!\&))(?:(.*?)=(.*?))(?:&|$)/g;
  if (hrefObj.search !== '') {
    const regex = /(?:\?|(?!\&))(?:(.*?)=(.*?))(?:&|$)/g;
    const str = hrefObj.search;
    let matches = []
    let m;

    while ((m = regex.exec(str)) !== null) {
        // This is necessary to avoid infinite loops with zero-width matches
        if (m.index === regex.lastIndex) {
            regex.lastIndex++;
        }

        // The result can be accessed through the `m`-variable.
        m.forEach((match, groupIndex) => {
            // console.log(`Found match, group ${groupIndex}: ${match}`);
            matches.push(match);
        });
    }

    for (var i = 1; i < matches.length; i += 3) {
      hrefObj.queries.push({
        key: matches[i],
        value: matches[i + 1]
      });
    }
  }

  // Replace undefined values with ''
  for (let value in hrefObj) {
    if (typeof hrefObj[value] === 'undefined') hrefObj[value] = '';
  }

  return hrefObj;
}

function isHrefOriginCurrent(documentLocation, origin) {
  return origin === documentLocation.origin;
}

function cleanPath(path) {
  // Remove trailing slash
  // Ignore base '/' path
  if (path.length > 1 && path[path.length - 1] === '/') path = path.substr(0, path.length - 1);

  // Add prefix '/' to path if not present
  if (path[0] !== '/') path = '/' + path;

  return path;
}

function comparePathToParamPath(path, paramPath, paramString) {
  let pathArray = path.split('/');
  let pathParamArray = paramPath.split('/');
  let paramIndex = pathParamArray.indexOf(paramString);
  let allEqual = true;
  // Compare all sections for overall equality, except for :param
  for (let i = 0; i < pathArray.length; i += 1) {
    if (i === paramIndex) continue;
    if (pathArray[i] !== pathParamArray[i]) allEqual = false;
  }
  return {
    success: allEqual,
    param: pathArray[paramIndex]
  };
}

function getRouteFromHref(routes, href) {
  // Parse href into origin, hostname and path
  href = parseHref(document.location, href);

  // Null/mailto/incorrectly formatted href
  if (!href) return false;

  // If origin is not site origin, not a router link
  if (!isHrefOriginCurrent(document.location, href.origin)) return false;

  // Extracts :param tags for routes
  let paramReg = /:(.*?)(?:\/|$)/;

  // Find route corresponding to href
  for (let i = 0; i < routes.length; i += 1) {
    // Check if route is a param path
    let paramTest = paramReg.exec(routes[i].path);
    if (paramTest !== null) {
      let result = comparePathToParamPath(href.pathname, routes[i].path, paramTest[0]);
      // If param is from this route
      if (result.success) {
        return routes[i];
      }
    }
    // Compare for pure equality
    else {
      if (routes[i].path === href.pathname) return routes[i];
    }
  }

  // Not a router link
  return false;
}

function parseHrefToRouterLocation(currentRoute, href) {
  // Parse href into origin, hostname and path
  href = parseHref(document.location, href);

  // Null/mailto/incorrectly formatted href
  if (!href) return false;

  // If origin is not site origin, not a router link
  if (!isHrefOriginCurrent(href.origin)) return false;

  // Extracts :param tags for routes
  let paramReg = /:(.*?)(?:\/|$)/;

  // Check if route is a param path
  let paramTest = paramReg.exec(currentRoute.path);

  if (paramTest !== null) {
    let result = comparePathToParamPath(href.pathname, currentRoute.path, paramTest[0]);
    if (result.success) {
      let routerLocation = href;
      routerLocation[paramTest[1]] = result.param;
      if (typeof currentRoute.type !== 'undefined') routerLocation.type = currentRoute.type;
      if (typeof currentRoute.title !== 'undefined') routerLocation.title = currentRoute.title;
      return routerLocation;
    }
  }
  // Compare for pure equality
  else {
    if (currentRoute.path === href.pathname) {
      let routerLocation = href;
      return routerLocation;
    }
  }

  // Not a router link
  return false;
}

module.exports = {
  comparePathToParamPath,
  getRouteFromHref,
  parseHrefToRouterLocation,
  parseHref,
  isHrefOriginCurrent
}

// let splitHrefReg = /((?:(?:http|https):|)\/{2}([a-zA-z0-9-.]*|)|)((?:\/|).*)/;
// let splitHrefReg = /(((?:http|https):|)\/{2}([a-zA-z0-9-.]*|)|)((?:\/|).*)/;



// WEBPACK FOOTER //
// ../autor/src/href.js